import { connect } from '@cerebral/react'
import { CircularProgress, Tooltip } from '@mui/material'
import FileDownload from '@mui/icons-material/FileDownload'
import Check from '@mui/icons-material/Check'
import { props, sequences } from 'cerebral'
import PropTypes from 'prop-types'
import { keys } from 'ramda'
import { isNotNil } from 'ramda-adjunct'
import React, { useCallback, useEffect, useState } from 'react'
import ThemedIconButton from '../controls/ThemedIconButton'
import { useToggleState } from '../../lib/util/hooks'

function convertToCSV(list) {
  // Extract the headers from the first object
  const headers = keys(list[0])
  // Create CSV string starting with the headers
  const csvRows = []

  csvRows.push(headers.join(','))

  list.forEach((obj) => {
    const row = headers.map((header) => `"${isNotNil(obj[header]) ? obj[header] : ''}"`).join(',')
    csvRows.push(row)
  })
  return csvRows.join('\n')
}

const ExportCSV = connect(
  {
    //
    findBackground: sequences`${props`type`}s.find`,
  },
  ({ findBackground, type, options: { formatter, filename, findParams } }) => {
    const [loading, setLoading] = useState(false)
    const [success, successOn, successOff] = useToggleState(false)

    const downloadCSV = useCallback(async () => {
      if (loading) {
        return
      }

      setLoading(true)
      let data
      let result
      try {
        result = await findBackground({ fetchAll: true, silent: true, ...findParams })
        data = result?.entities[`${type}s`]
      } finally {
        setLoading(false)
      }

      if (!data) {
        return
      }

      const list = data.map(formatter)

      const csvData = convertToCSV(list)
      const blob = new Blob([csvData], { type: 'text/csv' })

      // Generate a download link and initiate the download
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
      successOn()
    }, [loading, filename, formatter, findParams, type])

    useEffect(() => {
      if (success) {
        setTimeout(successOff, 5000)
      }
    }, [success])

    return (
      <Tooltip title="Download as CSV" arrow>
        <div>
          <ThemedIconButton onClick={downloadCSV} size="small">
            {loading ? <CircularProgress color="inherit" size={20} /> : success ? <Check height="20" width="20" /> : <FileDownload height="20" width="20" />}
          </ThemedIconButton>
        </div>
      </Tooltip>
    )
  }
)

ExportCSV.propTypes = {
  type: PropTypes.string.isRequired,
  options: PropTypes.shape({
    formatter: PropTypes.func,
    filename: PropTypes.string,
    findParams: PropTypes.object,
  }),
}

export default ExportCSV
